import { AnyType, Box, BreakpointsProvider, classnames, Grid, IDefaultComponentProps } from '@centra/centra-ui'
import React, { FC, useCallback } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useHistory } from 'react-router-dom'
import { postTaskAction } from 'store/taskManager/actions'
import styles from './TaskListSidebar.module.scss'

const TaskListSidebarRemote = await import('tasktracker/TaskListSidebar').then(res => res)

export const TaskListContainer: FC<IDefaultComponentProps & { preChildren?: React.ReactNode; withGap?: boolean }> = ({
  className,
  style,
  children,
  preChildren,
  withGap,
}) => {
  const classes = classnames(className, styles.container, {
    [styles.containerWithGap]: withGap,
  })

  return (
    <>
      {preChildren}
      <Grid className={classes} style={style}>
        {children}
      </Grid>
      <Box className={styles.empty} />
    </>
  )
}

export const TaskListSidebar: FC = () => {
  const { task, filter } = useSelector(({ taskManager }) => taskManager)
  const dispatch = useDispatch()
  const history = useHistory()

  const handleGoToTask = useCallback(
    (id: number) => {
      history.push(`/task/${id}`)
    },
    [history]
  )

  const handlePostTask = useCallback((payload: AnyType, cb: AnyType) => {
    dispatch(postTaskAction(payload, cb))
  }, [])

  const Component = TaskListSidebarRemote.default.TaskListSidebar

  return (
    <Box className={styles.wrapper}>
      <BreakpointsProvider formFactor="DESKTOP">
        <Component
          className={styles.root}
          filter={filter}
          activeTask={task}
          goToTask={handleGoToTask}
          postTaskAction={handlePostTask}
          bg="basicWhite"
        />
      </BreakpointsProvider>
    </Box>
  )
}
